var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selected-product"},[_c('h4',{staticClass:"text-right ml-5 mr-5 mb-3"},[_vm._v("پیشنهادها")]),_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.products),function(product,index){return _c('ProductItem',{key:product[index],attrs:{"product":product,"vertical":true}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }